// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__HKkz7","footer":"ModalFilter_footer__1JaWp"};